import React from "react";
import { Heading as UIHeading } from "@usap/uicomponents";
export default function Heading({
  title = "",
  level = 5,
  size = "small",
  weight = "normal",
  color = "dark-2",
  ...props
}) {
  return (
    <UIHeading
      size={size}
      responsive={false}
      level={level}
      margin="0px"
      color={color}
      weight={weight}
      {...props}
      dangerouslySetInnerHTML={{
        __html: title
      }}
    />
  );
}
